import React from "react";
import "./CreateMemorial.css";
import greater from "../../../assets/icons/greater.svg";
import LovedOne from "../../components/lovedone/LovedOne";
import ChoosePlane from "../../components/creatememo_chooseplane/ChoosePlane";
import MemoLogin from "../../components/creatememo_login/MemoLogin";
import PrivacyOption from "../../components/privacyoption/PrivacyOption";
import { useUserContext } from "../../../context/MemorialContext";
import { useLocation } from "react-router-dom";

function CreateMemorial() {
  const location = useLocation();
  const {
    user,
    options,
    setOptions,
    handleSelected,
    showOption,
    setShowOption,
    formIsCompleted,
  } = useUserContext();

  const fromPayment = location.state?.fromPayment === true;
  const planStepComplete =
    user?.meta?.hasPaid ||
    fromPayment ||
    sessionStorage.getItem("memorialWizardAfterPayment") === "1" ||
    localStorage.getItem("package") != null;

  React.useEffect(() => {
    if (planStepComplete && sessionStorage.getItem("memorialWizardAfterPayment")) {
      sessionStorage.removeItem("memorialWizardAfterPayment");
    }

    setOptions([
      {
        title: "About your loved one",
        isCompleted: true,
        isActive: !formIsCompleted,
        show: true,
        component: <LovedOne title="About your loved one" /> || "",
      },
      {
        title: "Account details",
        isCompleted: false,
        isActive: formIsCompleted && !user,
        show: !user,
        component: <MemoLogin title="Account details" />,
      },
      {
        title: "Choose your plan",
        isCompleted: false,
        isActive: formIsCompleted && user && !planStepComplete,
        show: !planStepComplete,
        component: <ChoosePlane title="Choose your plan" />,
      },
      {
        title: "Privacy options",
        isCompleted: false,
        isActive: formIsCompleted && user && planStepComplete,
        show: true,
        component: <PrivacyOption title="Privacy options" />,
      },
    ]);

    if (formIsCompleted) {
      if (!user) {
        setShowOption({
          title: "Account details",
          isCompleted: false,
          isActive: false,
          show: !user,
          component: <MemoLogin title="Account details" />,
        });
      } else if (planStepComplete) {
        setShowOption({
          title: "Privacy options",
          isCompleted: false,
          isActive: true,
          show: true,
          component: <PrivacyOption title="Privacy options" />,
        });
      } else {
        setShowOption({
          title: "Choose your plan",
          isCompleted: false,
          isActive: true,
          show: true,
          component: <ChoosePlane title="Choose your plan" />,
        });
      }
    } else {
      setShowOption({
        title: "About your loved one",
        isCompleted: true,
        isActive: !formIsCompleted,
        show: true,
        component: <LovedOne title="About your loved one" /> || "",
      });
    }
  }, [user, formIsCompleted, planStepComplete, fromPayment, setOptions, setShowOption]);

  return (
    <div className="memrialpage">
      <h1>Create a memorial website</h1>
      {fromPayment && (
        <p style={{ marginBottom: "1rem", color: "#5c5470", fontSize: "0.95rem" }}>
          Almost done — choose privacy settings, then pick a theme to publish your
          memorial.
        </p>
      )}
      <div className="breadcrum">
        {options.map((item) => {
          return (
            <React.Fragment key={item.title}>
              {item.show && (
                <p
                  className={`${item.isActive ? "active" : "noActive"}`}
                  onClick={() => handleSelected(item)}
                >
                  {item.title}

                  <span>
                    <img src={greater} alt="" />
                  </span>
                </p>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="breadcrum_component">{showOption.component}</div>
    </div>
  );
}

export default CreateMemorial;
